<!-- =========================================================================================
  File Name: User List View.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
<div id="commandes-list-view" class="data-list-container">
    <vs-popup fullscreen title=" " :active.sync="popupActive">
        <commande-map-view :isActive="popupActive"></commande-map-view>
    </vs-popup>

    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="commandesEncours">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center">
                <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                    <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
                        <span class="mr-2">Actions</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>
                        <vs-dropdown-item>
                            <span class="flex items-center">
                                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Imprimer</span>
                            </span>
                        </vs-dropdown-item>

                        <vs-dropdown-item>
                            <span class="flex items-center">
                                <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                                <span>Exporter</span>
                            </span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ commandesEncours.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : commandesEncours.length }} of {{ queriedItems }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=4">
                        <span>4</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=10">
                        <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=20">
                        <span>20</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <template slot="thead">
            <vs-th sort-key="ncommande">N° Commande</vs-th>
            <vs-th sort-key="Type">Type</vs-th>
            <vs-th sort-key="cree_par">Commandé Par</vs-th>
            <vs-th sort-key="cree_le">Date Commande</vs-th>
            <vs-th sort-key="Status">Status</vs-th>
            <vs-th sort-key="Visualiser">Visualiser</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <p class="product-category">{{ tr.No }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="product-category">{{ tr.Order_Type }}</p>
                    </vs-td>
                    <vs-td>
                        <vx-tooltip v-if="tr.Assigned_User_ID!='COGEPHA\\ADACTIM'" :text="tr.Assigned_User_ID" position="bottom">
                            <vs-avatar :src="activeUserInfo.photo" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                        </vx-tooltip>
                        <vx-tooltip v-else :text="tr.Ship_to_Name" position="bottom">
                            <vs-avatar :src="activeUserInfo.photo" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                        </vx-tooltip>
                    </vs-td>
                    <vs-td>
                        <p class="product-category">{{ tr.Posting_Date.substring(0,10) }}</p>
                    </vs-td>

                    <vs-td>
                        <center>
                            <vs-chip id="vs-chip" :color="getOrderStatusColor(tr.Order_status)">{{ tr.Order_status }}</vs-chip>
                        </center>
                    </vs-td>
                    <vs-td class="whitespace-no-wrap">
                        <!-- <feather-icon icon="MapPinIcon"    svgClasses="              bg-danger  stroke-current  text-dark  round       w-5 h-5    " class="ml-8" @click="tomaps(tr.livreur.id)" /> -->
                        <vx-tooltip text="Voir sur map " position="bottom" color="primary">
                            <img v-if="tr.Order_status=='expédiée'" key="onlineImg" :src="imgMaps" alt="user-img" width="20" height="20" class="ml-4" @click="tomaps(tr.Driver_No)" />
                        </vx-tooltip>
                        <vx-tooltip text="Pas en route " position="bottom" color="red">
                            <img v-if="tr.Order_status!='expédiée'" key="onlineImg" :src="imgNoEyes" alt="user-img" width="20" height="20" class="ml-4" />
                        </vx-tooltip>
                    </vs-td>
                </vs-tr>
            </tbody>
        </template>
    </vs-table>
</div>
</template>

<script>
import DataViewSidebar from "./modals/DataViewSidebar.vue";
import moduleDataList from "@/store/data-list/moduleDataList.js";
import CommandeMapView from "./CommandeMapView.vue";
import l from "../../http/requests/serviceaideclients/index";

export default {
    components: {
        DataViewSidebar,
        CommandeMapView
    },
    data() {
        return {
            popupActive: false,
            etat: false,
            selected: [],
            // products: [],
            itemsPerPage: 10,
            isMounted: false,
            addNewDataSidebar: false,
            sidebarData: {},
            imgMaps: require("@/assets/images/portrait/small/view5.png"),
            imgNoEyes: require("@/assets/images/portrait/small/noeye.png")
        };
    },
    computed: {
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
        activeUserInfo() {
            return this.$store.state.AppActiveUser;
        },
        commandesEncours() {
            //  console.log(this.$store.state.dataList.commandesEncours)
            return this.$store.state.dataList.commandesEncours;
        },
        queriedItems() {
            return this.$refs.table ?
                this.$refs.table.queriedResults.length :
                this.commandesEncours.length;
        }
    },
    methods: {
        getOrderStatusColor(status) {
            // if (status == "en_cours") return "warning";
            if (status == " ") return "default";
            // if (status == "livrée") return "success";
            // if (status == "en attente de préparation") return "red";
            // if (status == "en attente d'expédition") return "blue";
            // if (status == "en cours de tirage") return "black";
            if (status == "expédiée") return "primary";
            return "primary";
        },
        getPopularityColor(num) {
            if (num > 90) return "success";
            if (num > 70) return "primary";
            if (num >= 50) return "warning";
            if (num < 50) return "danger";
            return "primary";
        },
        toggleDataSidebar(val = false) {
            this.addNewDataSidebar = val;
        },
        toStatus(id) {
            // ici appel de service qui retourne le statut de commande

            //this.$store.state.AppActiveLivreur.id=6
            //  this.$store.dispatch("dataList/fetchLivreurPosActuelle")
            console.log(id);
            return new Promise((resolve, reject) => {
                l.livreurPosActuelle(6)
                    .then(response => {
                        this.$vs.dialog({
                            color: "primary",
                            title: `Commande ` + id,
                            text: "Votre Commande est en ..." +
                                response.data.latitude +
                                response.data.longtitude,
                            acceptText: "Terminer"
                        });
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        tomaps(id) {
            this.$store.dispatch("updateActiveLiv", {
                id: id
            });
            this.popupActive = true;
        },
        loadData() {
            this.$store
                .dispatch("dataList/fetchDataListCommmandesEncours")
                .then(response => {
                    console.log(response);
                    this.$vs.loading.close();
                })
                .catch(error => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        title: "Erreur s'est produite lors de la récupération des données",
                        text: error.data,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circles"
                    });
                });
            // if (!moduleDataList.isRegistered) {
            //     this.$store.registerModule("dataList", moduleDataList);
            //     moduleDataList.isRegistered = true;
            // }

            // if (this.$store.state.AppActiveUser.id != 0)
            //     this.$store.dispatch("dataList/fetchDataListCommmandesEncours");
            // this.$store.subscribe(mutation => {
            //     if (mutation.type === "UPDATE_USER_INFO")
            //         this.$store.dispatch("dataList/fetchDataListCommmandesEncours");
            // });
        }
    },
    created() {
        if (!moduleDataList.isRegistered) {
            this.$store.registerModule("dataList", moduleDataList);
            moduleDataList.isRegistered = true;
        }
        this.$vs.loading();
        if (this.$store.state.AppActiveUser.id != 0) {
            this.loadData();
        }
        this.$store.subscribe(mutation => {
            if (mutation.type === "UPDATE_USER_INFO") {
                this.loadData();
            }
        });
    },
    mounted() {
        this.isMounted = true;
    }
};
</script>

<style lang="scss">
#commandes-list-view {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }
}
</style>
